import * as yup from 'yup';

export const raceSchema = yup.object({
    name: yup.string().label('name').required('Este campo es requerido'),
});

export type raceSchemaType = yup.InferType<typeof raceSchema>
